<template>
    <div class="flex-root-column replacements">
        <RibbonCodes
            class="noselect"
            ref="ribbon"
            :columns="columns"
            :codeType="currentCodeType"
            :codeTypes="codeTypes"
            @updateView="updateView"
            @displayOtherLanguages="displayOtherLanguages"
            @saveCodes="saveCodes"
            @addNewCode="addNewCode"
        />
        <CedexCodeEditor
            ref="cedexCodeEditor"
            :columns="columns"
            :code-type="currentCodeType"
            @showMessage="showMessage"
        />
        <v-snackbar
            v-model="messageBox.show"
            :timeout="messageBox.closeTimeout"
            light
            class="coa_snack"
            :class="'coa_' + messageBox.type"
        >
            {{ messageBox.content }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-show="messageBox.closeTimeout === 0"
                    v-bind="attrs"
                    @click="messageBox.show = false"
                >
                    {{ messageBox.closeButtonText }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import CedexCodeEditor from "../components/Codes/CedexCodeEditor.vue";
import RibbonCodes from "../components/Ribbon/RibbonCodes.vue";
import i18n from "../i18n";

export default {
    name: 'Codes',
    components: {CedexCodeEditor, RibbonCodes},
    created() {
        this.$emit('updateHeaderNavigation', [{
            display: i18n.t('CEDEX Codes')
        }]);
    },
    data() {
        return {
            currentCodeType: 'location',
            codeTypes: {
                location:  'Location',
                component: 'Component',
                damage:    'Damage',
                repair:    'Repair',
                material:  'Material'
            },
            columns: [
                {id: 'code',          title: 'Code',                  visible: true,  width: 80, filter: true, required: true},
                {id: 'name',          title: 'Name',                  visible: true,             filter: true, required: true},
                {id: 'description',   title: 'Description',           visible: true,             filter: true},
                {id: 'nameDe',        title: 'Name (german)',         visible: false,            filter: true},
                {id: 'descriptionDe', title: 'Description (german)',  visible: false,            filter: true},
                {id: 'nameRu',        title: 'Name (russian)',        visible: false,            filter: true},
                {id: 'descriptionRu', title: 'Description (russian)', visible: false,            filter: true},
                {id: 'equipment',     title: 'Equipment',             visible: false, width: 200, filter: true, required: true},
                {id: 'active',        title: 'Active',                visible: true,  width: 80, filter: true},
                {id: 'actions',       title: 'Actions',               visible: true,  width: 80},
            ],
            otherLanguageColumns: [
                'nameDe',
                'descriptionDe',
                'nameRu',
                'descriptionRu',
            ],
            messageBox: {
                show:            false,
                content:         '',
                closeButtonText: 'ok',
                closeTimeout:    -1,
            },
        }
    },
    props: {
        viewMode: {
            type: String,
            default: 'default'
        }
    },
    methods: {
        updateView(type, value) {
            if (type === 'codeType') {
                this.currentCodeType = value;
            }
            this.$refs.cedexCodeEditor.updateView(type, value);
        },
        displayOtherLanguages(display) {
            this.columns.forEach((column) => {
                if (this.otherLanguageColumns.includes(column.id)) {
                    column.visible = display;
                }
            });
        },
        saveCodes() {
            this.$refs.cedexCodeEditor.saveCodes();
        },
        addNewCode() {
            this.$refs.cedexCodeEditor.addNewCode();
        },
        showMessage(content, type, close, buttonText) {
            this.messageBox.content = content;
            this.messageBox.type = type;
            this.messageBox.show = true;
            if (typeof close === 'number') {
                this.messageBox.closeTimeout = close;
            } else {
                this.messageBox.closeTimeout = -1;
            }
            if (buttonText) {
                this.messageBox.closeButtonText = buttonText;
            } else {
                this.messageBox.closeButtonText = 'ok';
            }
        }
    }
}
</script>